/**
 * 阿里云 OSS 配置
 * 
 * 如果后端接口不返回 bucket、region、endpoint 等信息，
 * 可以在这里配置默认值
 */

interface OssConfig {
  bucket: string
  region: string
  endpoint?: string
}

// 根据环境获取 OSS 配置
export function getOssConfig(): OssConfig {
  const env = import.meta.env.MODE

  // 可以根据不同环境配置不同的 bucket
  const configs: Record<string, OssConfig> = {
    dev: {
      bucket: 'hrac-zktp',
      region: 'oss-cn-hangzhou'
    },
    test: {
      bucket: 'hrac-zktp',
      region: 'oss-cn-hangzhou'
    },
    prod: {
      bucket: 'hrac-zktp',
      region: 'oss-cn-hangzhou'
    }
  }

  return configs[env] || configs.dev
}

// 导出默认配置
export const defaultOssConfig = getOssConfig()
